(function(){
  'use strict';
  if(!window.matchMedia || !window.matchMedia('(max-width:1024px)').matches) return;

  function q(sel,root){ return (root||document).querySelector(sel); }
  function qa(sel,root){ return Array.prototype.slice.call((root||document).querySelectorAll(sel)); }

  function currentSearchOverlay(){
    var overlays=qa('[data-mg2-search-overlay]');
    if(!overlays.length) return null;
    var fresh=overlays.filter(function(el){ return !!el.closest('.mg2-header'); })[0];
    return fresh || overlays[overlays.length-1];
  }

  function setLock(on){
    document.documentElement.classList.toggle('mg2-lock',!!on);
    if(document.body) document.body.classList.toggle('mg2-lock',!!on);
  }

  function closeDrawer(){
    var drawer=q('[data-mg2-mobile-drawer]');
    if(!drawer) return;
    var active=document.activeElement;
    if(active && drawer.contains(active)){ try{active.blur();}catch(e){} }
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden','true');
    qa('[data-mg2-mobile-open]').forEach(function(btn){btn.setAttribute('aria-expanded','false');});
  }

  function openSearch(){
    var overlay=currentSearchOverlay();
    if(!overlay) return;
    closeDrawer();
    overlay.hidden=false;
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden','false');
    qa('[data-mg2-search-open]').forEach(function(btn){btn.setAttribute('aria-expanded','true');});
    setLock(true);
    var input=q('[data-mg2-live-search-input]',overlay) || q('input[type="search"]',overlay);
    window.setTimeout(function(){
      if(input && document.contains(input)){ try{input.focus({preventScroll:true});}catch(e){try{input.focus();}catch(_){} } }
    },40);
  }

  function closeSearch(){
    var overlay=currentSearchOverlay();
    if(overlay){
      var active=document.activeElement;
      if(active && overlay.contains(active)){ try{active.blur();}catch(e){} }
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden','true');
    }
    qa('[data-mg2-search-open]').forEach(function(btn){btn.setAttribute('aria-expanded','false');});
    setLock(false);
  }

  function cleanupForNavigation(){
    closeSearch();
    closeDrawer();
    document.documentElement.style.overflow='';
    if(document.body) document.body.style.overflow='';
  }

  /* One stable delegated controller. No document-wide MutationObserver. */
  document.addEventListener('click',function(event){
    var open=event.target && event.target.closest && event.target.closest('[data-mg2-search-open]');
    if(open){
      event.preventDefault();
      event.stopPropagation();
      openSearch();
      return;
    }

    var close=event.target && event.target.closest && event.target.closest('[data-mg2-search-close]');
    if(close){
      event.preventDefault();
      event.stopPropagation();
      closeSearch();
      return;
    }

    var overlay=currentSearchOverlay();
    if(!overlay) return;

    if(event.target===overlay){
      event.preventDefault();
      closeSearch();
      return;
    }

    /* Release every scroll/focus lock BEFORE Shopify or the browser follows a result. */
    var navigationLink=event.target && event.target.closest && event.target.closest('.mg2-search-result[href],[data-mg2-search-all][href]');
    if(navigationLink && overlay.contains(navigationLink)){
      cleanupForNavigation();
    }
  },true);

  document.addEventListener('keydown',function(event){
    var overlay=currentSearchOverlay();
    if(event.key==='Escape' && overlay && overlay.classList.contains('is-open')){
      event.preventDefault();
      closeSearch();
    }
  },true);

  document.addEventListener('submit',function(event){
    var form=event.target && event.target.closest && event.target.closest('[data-mg2-live-search-form]');
    if(form) cleanupForNavigation();
  },true);

  /* Navigation lifecycle cleanup. These are finite events, not DOM observers. */
  window.addEventListener('pagehide',cleanupForNavigation);
  window.addEventListener('beforeunload',cleanupForNavigation);
  window.addEventListener('pageshow',function(){
    setLock(false);
    var overlay=currentSearchOverlay();
    if(overlay && overlay.getAttribute('aria-hidden')==='true') overlay.classList.remove('is-open');
  });
  ['shopify:navigation:complete','theme:page:load','page:load','turbo:load'].forEach(function(name){
    document.addEventListener(name,cleanupForNavigation);
  });
})();
